import { X, AlertOctagon, Receipt } from 'lucide-react';

// ERRO GRAVE: produto vendido com custo médio zerado no ERP. Não fecha sozinha —
// precisa ser fechada manualmente para garantir que alguém viu.
export default function NotificacaoCustoMedioZerado({ notificacao, onClose }) {
  const d = notificacao.dados;

  const fmt = (val) =>
    Number(val).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  return (
    <div className="w-96 bg-white rounded-xl shadow-2xl border-2 border-red-800 overflow-hidden animate-slide-in">
      {/* Header */}
      <div className="bg-red-900 px-4 py-3 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center flex-shrink-0">
            <AlertOctagon className="w-6 h-6 text-red-800" />
          </div>
          <div className="text-white">
            <h3 className="font-bold text-base leading-tight">ERRO GRAVE</h3>
            <p className="text-xs opacity-80">Produto vendido com custo médio zerado</p>
          </div>
        </div>
        <button onClick={onClose} className="text-white hover:bg-white/20 rounded-lg p-1.5 transition-colors">
          <X className="w-5 h-5" />
        </button>
      </div>

      {/* Conteúdo */}
      <div className="p-4 space-y-3">
        <div className="bg-red-50 rounded-lg p-3 border border-red-300">
          <div className="flex items-center gap-2 text-red-800 text-xs mb-1">
            <Receipt className="w-3.5 h-3.5" />
            Venda
          </div>
          <p className="font-bold text-gray-900 text-2xl">{d.sequencia}</p>
          <p className="text-xs text-gray-500 mt-1">{d.forma_pagamento}</p>
          {d.vendedor && <p className="text-xs text-gray-500">Vendedor: {d.vendedor}</p>}
        </div>

        <div className="space-y-1.5">
          {(d.itens || []).map((it, idx) => (
            <div key={idx} className="bg-red-50 border border-red-300 rounded-lg px-3 py-2">
              <p className="text-xs font-semibold text-gray-800 truncate">
                {it.codigo_produto} — {it.nome_produto}
              </p>
              <p className="text-xs text-red-700 mt-0.5">
                Vendido por R$ {fmt(it.preco_vendido)} com custo médio R$ 0,00
              </p>
            </div>
          ))}
        </div>

        <p className="text-xs text-red-800 font-medium">
          Corrija o custo médio do produto no ERP (tabela CUSTO MÉDIO).
        </p>
      </div>
    </div>
  );
}
